module.exports = __webpack_public_path__ + "img/Pablo.cb31bca0.png";